module.exports = __webpack_public_path__ + "static/media/card-danger.48578653.png";